import styled from "styled-components";


export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const TopContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const TopContentHeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
export const TopContentHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
`;


export const MetadataContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;
export const MetaItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const AgentCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ActionContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
`;
